export default __webpack_public_path__ + "static/media/clay-banks-VK-podfv2DU-unsplash.0c446c1b.jpg";